// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notification[data-v-2bec9446]{background:#fff;display:flex;align-items:center;padding:10px;border-top:1px solid #ddd;font-size:16px;justify-content:space-between;border-left:9px solid #ff1c43}.notification img[data-v-2bec9446]{margin:0 6px 0 15px;cursor:pointer}.notification.error[data-v-2bec9446]{color:#ff1c43}", ""]);
// Exports
module.exports = exports;
